import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { getDecryptedToken } from "../../../../../../app/auth/authHandler";
import { Button } from "@mui/material";
import {
  addOrUpdateCartAsync,
  fetchCartListAsync,
  removeItemFromCartAsync,
} from "../../../../../../app/slices/cartSlice/CartSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
import { getPeopleBaughtListAsync } from "../../../../../../app/slices/productList/productListingSlice";
import { setSelectProduct } from "../../../../../../app/slices/productDiscriptionSlice/ProductDescriptionSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import ConfirmationDialog from "../../../../../components/custom/confirm";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../../../../../components/custom/dialog";
import { CouponComponent } from "./CouponCodes";
import { QuickAddModal } from "../../../../public/productListPage/components/quickAdd/quickAdd";
import { getProductImageUrl } from "../../../../../../app/slices/common/imageConstants";
interface MyCartProps {
  page: any;
}
interface CustomizationEntry {
  custom_id?: number | null;
  custom_note: string;
  custom_image: any;
}
export const MyCart: React.FC<MyCartProps> = ({ page }) => {
  const [quantities, setQuantities] = useState<{ [skuId: number]: number }>({});
  const { addTocart } = useAppSelector((state) => state.CartState);
  const billingData = addTocart.billingData;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmId, setConfirmId] = useState("");
  const navigate = useNavigate();
  const [modalType, setModalType] = useState("");
  const [customizations, setCustomizations] = useState<
    Record<number, CustomizationEntry[]>
  >({});
  const [peopleList, setPeopleList] = useState<any[]>([]);

  useEffect(() => {
    const quantities = addTocart?.data?.reduce((acc: any, item: any) => {
      acc[item.sku_id] = item.quantity;
      return acc;
    }, {});
    setQuantities(quantities);
  }, [addTocart?.data]);

  const dispatch = useAppDispatch();
  const openDialog = (id: any) => {
    setConfirmId(id);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setConfirmId("");
    setDialogOpen(false);
  };
  const confirmAction = () => {
    handleRemoveClick(confirmId);
    closeDialog();
  };
  const handleQuantityChange = (
    skuId: number | undefined,
    action: "increase" | "decrease",
    cart_item_id: number
  ) => {
    if (skuId === undefined) return;

    setQuantities((prevQuantities) => {
      const currentQuantity = prevQuantities[skuId] || 0;
      const maxQuantity = Infinity;

      const newQuantity =
        action === "increase"
          ? Math.min(currentQuantity + 1, maxQuantity)
          : Math.max(currentQuantity - 1, 0);

      if (newQuantity === 0) {
        dispatch(removeItemFromCartAsync(cart_item_id)).then(
          (response: any) => {
            if (response?.payload?.status === 200) {
              const aId = localStorage.getItem("aId");
              const accessToken = getDecryptedToken();
              const anonymous_id = accessToken ? null : aId ? aId : null;

              dispatch(fetchCartListAsync(anonymous_id));
              // dispatch(fetchCartListAsync());
              // navigate("/");
            }
          }
        );
      } else if (newQuantity !== currentQuantity) {
        const updatedQuantities = Object.entries(prevQuantities).map(
          ([sku, quantity]) => {
            if (Number(sku) === skuId) {
              return { sku: Number(sku), quantity: newQuantity };
            } else {
              return { sku: Number(sku), quantity };
            }
          }
        );

        const payload: any = {
          skus: updatedQuantities,
        };
        const aId = localStorage.getItem("aId");
        const accessToken = getDecryptedToken();
        if (aId && accessToken == null) {
          payload.anonymous_id = aId;
        }
        dispatch(addOrUpdateCartAsync(payload));
      }
      return {
        ...prevQuantities,
        [skuId]: newQuantity, // Update the quantity for the SKU
      };
    });
  };

  const handleRemoveClick = (cart_item_id: any) => {
    dispatch(removeItemFromCartAsync(cart_item_id)).then((response: any) => {
      if (response?.payload?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Item removed succesfuly.",
            severity: "success",
            autoHide: 2000,
          })
        );
        if (addTocart?.data.length === 1 || addTocart?.data.length === 0) {
          navigate("/");
        }
        // dispatch(fetchCartListAsync());
        const aId = localStorage.getItem("aId");
        const accessToken = getDecryptedToken();
        const anonymous_id = accessToken ? null : aId ? aId : null;

        dispatch(fetchCartListAsync(anonymous_id));
      } else {
        dispatch(
          showSnackbar({
            message: "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    });
  };
  const onCloseModal = () => {
    setModalType("");
  };
  const removeCoupon = () => {
    const payload: any = {
      skus: Object.entries(quantities)?.map(([sku, quantity]) => ({
        sku: Number(sku),
        quantity,
      })),
      remove_coupon: true,
    };
    dispatch(addOrUpdateCartAsync(payload));
  };

  // People also bought: read from product list slice
  const { peopleBaughtList } = useAppSelector(
    (state) => state.ProductsListState
  );

  useEffect(() => {
    if (peopleBaughtList?.values?.length) {
      setPeopleList(peopleBaughtList.values || []);
    }
  }, [peopleBaughtList?.values]);

  useEffect(() => {
    if (addTocart?.data?.length && !peopleBaughtList?.values?.length) {
      const aId = localStorage.getItem("aId");
      const accessToken = getDecryptedToken();
      const anonymous_id = accessToken ? null : aId ? aId : null;
      dispatch(getPeopleBaughtListAsync({ anonymous_id, product_id: "" }));
    }
  }, [addTocart?.data, peopleBaughtList?.values, dispatch]);

  const selectProduct = (id: any) => {
    dispatch(setSelectProduct(id));
    localStorage.setItem("product_id", id);
  };
  const onOpenModal = (type: string) => {
    setModalType(type);
  };

  const customizableItems = useMemo(() => {
    if (!addTocart?.data) {
      return [];
    }

    return addTocart.data.filter((item: any) => {
      const quantityForItem = Math.max(
        0,
        Number(quantities[item.sku_id] ?? item?.quantity ?? 0)
      );
      return item?.customization_available && quantityForItem > 0;
    });
  }, [addTocart?.data, quantities]);

  // Populate customizations from API response (customization_items)
  useEffect(() => {
    setCustomizations((prev) => {
      const next: Record<number, CustomizationEntry[]> = {};

      // First, check global customization_items array
      const globalCustomizationItems = addTocart?.customization_items;
      if (
        globalCustomizationItems &&
        Array.isArray(globalCustomizationItems) &&
        globalCustomizationItems.length > 0
      ) {
        // Group customization_items by cart_item_id
        const groupedByCartItem: Record<number, any[]> = {};
        globalCustomizationItems.forEach((customItem: any) => {
          const cartItemId = customItem.cart_item_id;
          if (!groupedByCartItem[cartItemId]) {
            groupedByCartItem[cartItemId] = [];
          }
          groupedByCartItem[cartItemId].push(customItem);
        });

        // For each cart item with customizations, map them to entries
        Object.keys(groupedByCartItem).forEach((cartItemIdStr) => {
          const cartItemId = Number(cartItemIdStr);
          const customItems = groupedByCartItem[cartItemId];

          // Sort by custom_image_id to maintain order (e.g., "124_1", "124_2")
          customItems.sort((a, b) => {
            const aId = a.custom_image_id || "";
            const bId = b.custom_image_id || "";
            // Extract the index part (after underscore) for proper numeric sorting
            const aIndex = parseInt(aId.split("_")[1] || "0", 10);
            const bIndex = parseInt(bId.split("_")[1] || "0", 10);
            return aIndex - bIndex;
          });

          // Map customizations to array, using custom_image_id to determine index
          const entries: CustomizationEntry[] = [];
          customItems.forEach((customItem: any) => {
            // Parse custom_image_id to get index (e.g., "124_1" -> index 0, "124_2" -> index 1)
            const imageIdParts = (customItem.custom_image_id || "").split("_");
            const index =
              imageIdParts.length > 1
                ? parseInt(imageIdParts[1], 10) - 1
                : entries.length;

            // Ensure array is large enough
            while (entries.length <= index) {
              entries.push({
                custom_id: null,
                custom_note: "",
                custom_image: "",
              });
            }

            entries[index] = {
              custom_id: customItem.custom_id ?? null,
              custom_note: customItem.custom_note ?? "",
              custom_image: customItem.custom_image ?? "",
            };
          });

          next[cartItemId] = entries;
        });
      }

      // Second, check per-item customization_items arrays (prioritize these over global)
      if (addTocart?.data && Array.isArray(addTocart.data)) {
        addTocart.data.forEach((item: any) => {
          const cartItemId = item.cart_item_id;
          const itemCustomizationItems = item.customization_items;

          // Process if this item has its own customization_items array (overrides global if exists)
          if (
            itemCustomizationItems &&
            Array.isArray(itemCustomizationItems) &&
            itemCustomizationItems.length > 0
          ) {
            // Sort by custom_image_id to maintain order (e.g., "124_1", "124_2")
            const sortedItems = [...itemCustomizationItems].sort(
              (a: any, b: any) => {
                const aId = a.custom_image_id || "";
                const bId = b.custom_image_id || "";
                const aIndex = parseInt(aId.split("_")[1] || "0", 10);
                const bIndex = parseInt(bId.split("_")[1] || "0", 10);
                return aIndex - bIndex;
              }
            );

            // Map customizations to array, using custom_image_id to determine index
            const entries: CustomizationEntry[] = [];
            sortedItems.forEach((customItem: any) => {
              // Parse custom_image_id to get index (e.g., "124_1" -> index 0, "124_2" -> index 1)
              const imageIdParts = (customItem.custom_image_id || "").split(
                "_"
              );
              const index =
                imageIdParts.length > 1
                  ? parseInt(imageIdParts[1], 10) - 1
                  : entries.length;

              // Ensure array is large enough
              while (entries.length <= index) {
                entries.push({
                  custom_id: null,
                  custom_note: "",
                  custom_image: "",
                });
              }

              entries[index] = {
                custom_id: customItem.custom_id ?? null,
                custom_note: customItem.custom_note ?? "",
                custom_image: customItem.custom_image ?? "",
              };
            });

            // Override with per-item customizations if they exist
            next[cartItemId] = entries;
          }
        });
      }

      // Merge with existing customizations for items not in API response
      Object.keys(prev).forEach((key) => {
        const numericKey = Number(key);
        if (!next[numericKey]) {
          next[numericKey] = prev[numericKey];
        }
      });

      return next;
    });
  }, [addTocart?.customization_items, addTocart?.data]);

  // Helper to check if an item has existing customizations
  const hasExistingCustomizations = useCallback(
    (cartItemId: number) => {
      const entries = customizations[cartItemId] ?? [];
      return entries.some(
        (entry) =>
          (entry.custom_id !== null && entry.custom_id !== undefined) ||
          (entry.custom_note && entry.custom_note.trim() !== "") ||
          (entry.custom_image && entry.custom_image.trim() !== "")
      );
    },
    [customizations]
  );
  useEffect(() => {
    setCustomizations((prev) => {
      let hasChange = false;
      const next: Record<number, CustomizationEntry[]> = {};

      customizableItems.forEach((item: any) => {
        const key = item.cart_item_id;
        const quantityForItem = Math.max(
          0,
          Number(quantities[item.sku_id] ?? item?.quantity ?? 0)
        );
        const existing = prev[key] || [];
        const normalized: CustomizationEntry[] = [];

        for (let i = 0; i < quantityForItem; i += 1) {
          if (existing[i]) {
            normalized.push(existing[i]);
          } else {
            hasChange = true;
            normalized.push({
              custom_id: null,
              custom_note: "",
              custom_image: "",
            });
          }
        }

        if (existing.length !== normalized.length) {
          hasChange = true;
        }

        next[key] = normalized;
      });

      Object.keys(prev).forEach((key) => {
        const numericKey = Number(key);
        if (!next[numericKey]) {
          hasChange = true;
        }
      });

      if (!hasChange) {
        return prev;
      }
      return next;
    });
  }, [customizableItems, quantities]);
  const updateCustomizationEntry = useCallback(
    (
      cartItemId: number,
      index: number,
      partial: Partial<CustomizationEntry>
    ) => {
      setCustomizations((prev) => {
        const existingEntries = prev[cartItemId] ? [...prev[cartItemId]] : [];
        const existingEntry = existingEntries[index];
        const updatedEntry: CustomizationEntry = {
          custom_id:
            partial.custom_id !== undefined
              ? partial.custom_id
              : existingEntry?.custom_id ?? null,
          custom_note:
            partial.custom_note !== undefined
              ? partial.custom_note
              : existingEntry?.custom_note ?? "",
          custom_image:
            partial.custom_image !== undefined
              ? partial.custom_image
              : existingEntry?.custom_image ?? "",
        };
        existingEntries[index] = updatedEntry;
        return {
          ...prev,
          [cartItemId]: existingEntries,
        };
      });
    },
    []
  );

  const handleCustomizationNoteChange = (
    cartItemId: number,
    index: number,
    event: ChangeEvent<HTMLTextAreaElement>
  ) => {
    const value = event.target.value;

    // Update the state
    updateCustomizationEntry(cartItemId, index, { custom_note: value });
  };
  const handleCustomizationImageChange = (
    cartItemId: number,
    index: number,
    file: File | null
  ) => {
    if (!file) {
      updateCustomizationEntry(cartItemId, index, { custom_image: "" });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      updateCustomizationEntry(cartItemId, index, {
        custom_image: file,
      });
    };
    reader.readAsDataURL(file);
  };
  const handleSaveCustomizations = () => {
    const cartItems = addTocart?.data ?? [];
    const skusPayload = cartItems
      .map((item: any) => {
        const quantityNumber = Number(
          quantities[item.sku_id] ?? item?.quantity ?? 0
        );
        if (quantityNumber <= 0) {
          return null;
        }
        const payloadItem: any = {
          sku: item.sku_id,
          quantity: quantityNumber,
        };
        if (item.customization_available) {
          const customizationEntries = customizations[item.cart_item_id] ?? [];
          payloadItem.customisation = Array.from(
            { length: quantityNumber },
            (_, index) => {
              const entry = customizationEntries[index];

              const customisationEntry: any = {
                custom_note: entry?.custom_note ?? "",
                custom_image: entry?.custom_image ?? "",
                custom_image_id: `${item.sku_id}_${index + 1}`,
              };
              // Include custom_id if it exists (for updates)
              if (entry?.custom_id !== null && entry?.custom_id !== undefined) {
                customisationEntry.custom_id = entry.custom_id;
              }
              return customisationEntry;
            }
          );
        }
        return payloadItem;
      })
      .filter((entry: any) => entry !== null);

    // Build FormData with skus JSON and image files
    const formData = new FormData();
    formData.append("skus", JSON.stringify(skusPayload));

    // Attach image files. The backend expects keys like "skuId_index" (custom_image_id)
    skusPayload.forEach((item: any) => {
      if (item.customisation && Array.isArray(item.customisation)) {
        item.customisation.forEach((entry: any) => {
          const fileCandidate = entry.custom_image;
          const key = entry.custom_image_id;
          // Only append if it's a File
          if (fileCandidate && fileCandidate instanceof File && key) {
            formData.append(key, fileCandidate);
          }
        });
      }
    });

    const aId = localStorage.getItem("aId");
    const accessToken = getDecryptedToken();
    if (aId && !accessToken) {
      formData.append("anonymous_id", aId);
    }

    dispatch(addOrUpdateCartAsync(formData)).then((response: any) => {
      if (response?.payload?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Customization saved successfully.",
            severity: "success",
            autoHide: 2000,
          })
        );
        const aId = localStorage.getItem("aId");
        const accessToken = getDecryptedToken();
        const anonymous_id = accessToken ? null : aId ? aId : null;

        dispatch(fetchCartListAsync(anonymous_id));
        const offCanvasEl = document.getElementById("messageoncake");
        const offcanvas = (window as any).bootstrap?.Offcanvas.getInstance(
          offCanvasEl
        );
        offcanvas?.hide();
      } else {
        dispatch(
          showSnackbar({
            message: "Unable to save customization. Please try again.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    });
  };

  return (
    <>
      <div className="tf-mini-cart-wrap card pt-4">
        {addTocart?.data?.length > 0 && (
          <div
            style={{
              fontFamily: "Albert Sans, sans-serif",
              display: "flex",
              flexDirection: "column",
            }}
            className="tf-mini-cart-main"
          >
            <h5 className="px-4 fs-20 fw-6">My cart</h5>

            {/* Scrollable product list */}
            <div className="tf-mini-cart-scroll">
              <div className="tf-mini-cart-items">
                {addTocart?.data?.map((item: any) => (
                  <div className="tf-mini-cart-item" key={item.sku_id}>
                    <div className="tf-mini-cart-image">
                      <a>
                        <img
                          src={getProductImageUrl(item?.product_image)}
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="tf-mini-cart-info">
                      <span className="title link">
                        {item?.sku_name} - {item?.sku_quantity} {item?.sku_unit}
                      </span>
                      <div className="price fw-6">₹{item?.offer_price}</div>
                      <div className="tf-mini-cart-btns">
                        <div className="wg-quantity small">
                          <Button
                            onClick={() =>
                              handleQuantityChange(
                                item.sku_id,
                                "decrease",
                                item.cart_item_id
                              )
                            }
                            className="btn-quantity minus-btn"
                            disabled={addTocart?.loader}
                            style={{
                              cursor:
                                quantities[item.sku_id] > 0
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          >
                            -
                          </Button>
                          <input
                            type="text"
                            value={quantities[item.sku_id] || 0}
                            readOnly
                          />
                          <Button
                            onClick={() =>
                              handleQuantityChange(
                                item.sku_id,
                                "increase",
                                item.cart_item_id
                              )
                            }
                            className="btn-quantity plus-btn"
                            disabled={addTocart?.loader}
                          >
                            +
                          </Button>
                        </div>
                        <div
                          className="tf-mini-cart-remove"
                          onClick={
                            () => openDialog(item.cart_item_id)
                            // () => handleRemoveClick(item.cart_item_id)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          Remove
                        </div>
                        <ConfirmationDialog
                          title="Confirm Action"
                          open={dialogOpen}
                          onClose={closeDialog}
                          onConfirm={confirmAction}
                          content="Are you sure you want to remove this item from cart?"
                        />
                      </div>
                      {item.customization_available &&
                        item.customization_available === true && (
                          <div className="mt-3">
                            <button
                              type="button"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#messageoncake"
                              aria-controls="messageoncake"
                              className="tf-btn radius-3 w-100 justify-content-center prime-b btn-add-note prime-txt p-2"
                            >
                              <span>
                                <i className="fa fa-cake-slice"></i>{" "}
                                {item?.customization_items?.length > 0
                                  ? "Edit message on Cake"
                                  : "Add message on Cake"}
                              </span>
                            </button>
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {peopleList?.length > 0 && (
              <div className="modal-shopping-cart">
                <div
                  className="tf-minicart-recommendations"
                  style={{ marginLeft: "1%" }}
                >
                  <div className="tf-minicart-recommendations-heading">
                    <div
                      className="tf-minicart-recommendations-title"
                      style={{ width: "50%" }}
                    >
                      People Also Bought
                    </div>
                    <div className="sw-dots mt-0 small style-2 cart-slide-pagination2"></div>
                  </div>
                  <div>
                    <div className="hover-sw-nav">
                      <Swiper
                        modules={[Navigation, Pagination, Thumbs]}
                        spaceBetween={10}
                        freeMode={true}
                        navigation={{
                          nextEl: ".nav-next-slider",
                          prevEl: ".nav-prev-slider",
                        }}
                        pagination={{
                          el: ".cart-slide-pagination2",
                          clickable: true,
                        }}
                        className="tf-cart-slide"
                        id="recommendations-swiper"
                      >
                        {peopleList?.map((item: any, index: any) => (
                          <SwiperSlide key={index}>
                            <div className="tf-minicart-recommendations-item">
                              <div
                                className="tf-minicart-recommendations-item-image"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                }}
                              >
                                <img
                                  data-src={getProductImageUrl(item?.product_img)}
                                  src={getProductImageUrl(item?.product_img)}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                              <div
                                className="tf-minicart-recommendations-item-infos flex-grow-1"
                                style={{ marginLeft: "1rem" }}
                              >
                                <span className="title">
                                  {item.product_name}
                                </span>
                                <div className="price">₹{item.offerprice}</div>
                              </div>
                              <div
                                className="tf-minicart-recommendations-item-quickview"
                                onClick={() => {
                                  onOpenModal("quickAdd");
                                  selectProduct(item?.product_id);
                                }}
                              >
                                <div className="btn-show-quickview quickview hover-tooltip">
                                  <span className="icon icon-view"></span>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      {/* <div className="nav-sw nav-next-slider box-icon w_46 round">
                              <span className="icon icon-arrow-left"></span>
                            </div>
                            <div className="nav-sw nav-prev-slider box-icon w_46 round">
                              <span className="icon icon-arrow-right"></span>
                            </div> */}

                      <div className="sw-dots style-2 sw-pagination-collection justify-content-center"></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {modalType === "quickAdd" && (
              <CustomDialog
                component={<QuickAddModal modalType={modalType} />}
                title="Quick Add"
                openDialog={modalType === "quickAdd"}
                handleCloseDialog={onCloseModal}
                modalPlace="center"
              />
            )}
            {/* Sticky Bill Details at bottom */}
            <div
              className={`${
                page === "checkOut" ? "tf-mini-my-cart-bottom" : ""
              }`}
              // style={{
              //   padding: 20,
              //   borderTop: "1px solid #eee",
              //   background: "#fff",
              //   position: "sticky",
              //   bottom: 0,
              //   zIndex: 10,
              // }}
            >
              <div
                style={{ fontFamily: "Albert Sans, sans-serif" }}
                className="tf-mini-cart-bottom-wrap"
              >
                {/* commented on 12/02  */}
                {/* <div className="coupon-box">
            <CustomInput
              label="Coupon code"
              name="couponcode"
              size="small"
              variant="outlined"
              fullWidth
            />
            <CustomButton size="small" name="Apply" />
          </div>
          <div className="tf-page-cart-note">
            <textarea
              name="note"
              rows={1}
              id="cart-note"
              placeholder="''Add Suggestions? we will pass on..''"
            ></textarea>
          </div> */}
                {addTocart?.data?.length > 0 && (
                  <>
                    {getDecryptedToken() && (
                      // !billingData?.coupon_code &&
                      <>
                        <button
                          type="button"
                          className="tf-btn  animate-hover-btn radius-3 w-100 justify-content-center orange-b btn-add-note orange-txt"
                          onClick={() => setModalType("couponCode")}
                        >
                          <span>
                            <i className="fa fa-birthday-cake"></i> Apply Coupon
                          </span>
                        </button>
                        {billingData?.coupon_code && (
                          <div className="coupon-d">
                            <div className="row align-items-center justify-content-between">
                              <div className="col-8">
                                <p>
                                  {billingData?.coupon_code} <br />
                                  <small
                                    style={{
                                      fontSize: "12px",
                                      color: "#ccc",
                                    }}
                                  >
                                    Offer applied on the bill
                                  </small>
                                </p>
                              </div>
                              <div className="col-4 text-end">
                                <button
                                  type="button"
                                  className="btn-link p-0 border-0 bg-transparent text-uppercase fw-bold"
                                  onClick={() => removeCoupon()}
                                >
                                  REMOVE
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
                <div
                  className="offcanvas offcanvas-end canvas-search"
                  id="messageoncake"
                >
                  <div className="canvas-wrapper">
                    <header className="tf-search-head">
                      <div className="title fw-5">
                        <div className="close">
                          <span
                            className="icon-close icon-close-popup"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                          ></span>
                        </div>
                      </div>
                    </header>
                    <div className="canvas-body p-0">
                      <div className="tf-search-content p-0">
                        <div className="tf-search-sticky mb-2">
                          {customizableItems.length > 0 ? (
                            customizableItems.map((item: any) => {
                              const quantityForItem = Math.max(
                                0,
                                Number(
                                  quantities[item.sku_id] ?? item?.quantity ?? 0
                                )
                              );
                              const entries =
                                customizations[item.cart_item_id] ?? [];
                              return Array.from({
                                length: quantityForItem,
                              }).map((_, index) => {
                                const textareaId = `note-${item.cart_item_id}-${index}`;
                                const fileInputId = `fileInput-${item.cart_item_id}-${index}`;
                                const customizationEntry = entries[index];
                                return (
                                  <div
                                    className="px-3"
                                    key={`${item.cart_item_id}-${index}`}
                                  >
                                    <div className="tf-mini-cart-items mx-3">
                                      <div className="tf-mini-cart-item row message-box-l align-items-center">
                                        <div className="col-2 tf-mini-cart-image px-0">
                                          <div>
                                            <img
                                              src={getProductImageUrl(item?.product_image)}
                                              className="img-fluid"
                                              alt={item?.sku_name || ""}
                                            />
                                          </div>
                                        </div>
                                        <div className="col tf-mini-cart-info">
                                          <div className="title mb-1">
                                            {item?.sku_name}
                                          </div>
                                          <div className="price fw-6">
                                            ₹{item?.offer_price}
                                          </div>
                                        </div>
                                        <div className="col-1 px-0">
                                          <span className="count-m">
                                            {index + 1}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="card msg-card-br mt-0">
                                      <div className="card-body px-3">
                                        <form>
                                          <fieldset className="box fieldset">
                                            <label htmlFor={textareaId}>
                                              Message to be written on Cake
                                            </label>
                                            <textarea
                                              className="text-start"
                                              id={textareaId}
                                              placeholder="Add your message"
                                              value={
                                                customizationEntry?.custom_note ??
                                                ""
                                              }
                                              onChange={(event: any) =>
                                                handleCustomizationNoteChange(
                                                  item.cart_item_id,
                                                  index,
                                                  event
                                                )
                                              }
                                            ></textarea>
                                          </fieldset>
                                          <fieldset className="box fieldset mt-2">
                                            <label htmlFor={fileInputId}>
                                              Add image to be printed on Cake
                                            </label>
                                            <br />
                                            <input
                                              accept="image/*"
                                              type="file"
                                              id="imageUpload"
                                              className="enq"
                                              name={fileInputId}
                                              onChange={(
                                                event: ChangeEvent<HTMLInputElement>
                                              ) => {
                                                const file =
                                                  event.target.files?.[0] ??
                                                  null;
                                                handleCustomizationImageChange(
                                                  item.cart_item_id,
                                                  index,
                                                  file
                                                );
                                              }}
                                            />
                                          </fieldset>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                );
                              });
                            })
                          ) : (
                            <div className="px-3 py-4 text-center">
                              <p>No customizable items in your cart.</p>
                            </div>
                          )}
                          {customizableItems.length > 0 && (
                            <>
                              <hr className="my-3" />
                              <div className="bottom p-3">
                                <div className="w-100 text-end">
                                  <button
                                    type="button"
                                    data-bs-dismiss="offcanvas"
                                    className="btn-second"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    id="toggleButton"
                                    className="btn-prime"
                                    onClick={handleSaveCustomizations}
                                    disabled={addTocart?.loader}
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="tf-page-cart-note">
              <textarea
                name="note"
                rows={1}
                id="cart-note"
                placeholder="''Add Suggestions? we will pass on..''"
              ></textarea>
            </div> */}
                <h3 className="mt-3">Bill Details</h3>
                <div className="tf-cart-totals-discounts">
                  <div className="tf-cart-total">Item Total</div>
                  <div className="tf-totals-total-value fw-6">
                    ₹{billingData.subtotal}
                  </div>
                </div>
                <div className="tf-cart-totals-discounts">
                  <div>Delivery fee </div>
                  <div>₹{billingData.delivery_fee} </div>
                </div>
                <hr />
                {/* commented on 12/02  */}

                {/* <div className="tf-cart-totals-discounts">
              <div>Delivery Tip</div>
              <div>
                <a href="#" className="orange-txt">
                  Add tip
                </a>
              </div>
            </div> */}
                {/* <div className="tf-cart-totals-discounts">
              <div>Platform Fee</div>
              <div>₹10.00</div>
            </div> */}
                <div className="tf-cart-totals-discounts">
                  <div>GST and Restaurant charges</div>
                  <div>₹{billingData.taxes_and_charges}</div>
                </div>
                <hr />
                <div className="tf-cart-totals-discounts">
                  <div className="tf-cart-total fw-6">To Pay</div>
                  <div className="tf-totals-total-value fw-6">
                    ₹{billingData.grand_total}
                  </div>
                </div>
                {/* commented on 12/02  */}

                <div className="tf-mini-cart-view-checkout">
                  <div className="tf-btn animate-hover-btn radius-3 w-100 justify-content-center orange-b btn-add-note">
                    <span>Savings of ₹{billingData.total_savings}</span>
                  </div>
                </div>
                <div className="mt-2">
                  <p>
                    <b>
                      Review your order and address details to avoid
                      cancellations.
                    </b>
                  </p>
                  <p>
                    Note: Please ensure your address and order details are
                    correct. This order, if cancelled, is no refundable
                  </p>
                  <p>
                    <a
                      onClick={() => {
                        navigate("/read-policy");
                      }}
                      className="orange-txt"
                    >
                      <b>Read Policy</b>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <CustomDialog
        component={
          <CouponComponent modalType={modalType} onCloseModal={onCloseModal} />
        }
        title=""
        openDialog={modalType === "couponCode"}
        handleCloseDialog={onCloseModal}
        modalPlace="right"
      />
    </>
  );
};
